/*
 * Created Date: Tuesday October 4th 2022
 * Author: Oskar Karnblad
 * License: Proprietary to Scaffcalc AB
 *
 * Copyright (c) 2022 Scaffcalc AB
 */
import { Chip } from "@mui/material";
import { CSSProperties, FC } from "react";

export interface ChipInterface {
  id: any;
  icon?: any;
  label: string;
  onClick?: (label: string) => void;
  onDoubleClick?: (label: string) => void;
  selected?: boolean;
  disabled?: boolean;
  sx?: CSSProperties;
}

const ChipCustom: FC<ChipInterface> = (props) => {
  const { id, icon, label, onClick, onDoubleClick, selected, sx, disabled } =
    props;

  return (
    <Chip
      id={id}
      icon={icon}
      label={label}
      variant={selected ? "filled" : "outlined"}
      color={selected ? "primary" : "default"}
      onClick={onClick ? () => onClick(id) : () => {}}
      onDoubleClick={onDoubleClick ? () => onDoubleClick(id) : () => {}}
      disabled={disabled}
      sx={{ color: "text.primary", padding: 2, ...sx }}
    />
  );
};

export default ChipCustom;
